import React from 'react';
import { Helmet } from 'react-helmet-async';

const LocalBusinessSchema: React.FC = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Cats About Town Tours",
    "description": "NYC's premier cat history walking tours. Explore feline history in Brooklyn Heights, Financial District, and Lower East Side.",
    "url": "https://catsabouttowntours.com",
    "telephone": "+1-917-555-CATS",
    "email": "catsabouttowntour@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "New York",
      "addressRegion": "NY",
      "addressCountry": "US",
      "streetAddress": "Brooklyn Heights, NYC"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "40.6962",
      "longitude": "-73.9961"
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Saturday", "Sunday"],
        "opens": "10:00",
        "closes": "16:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "10:00",
        "closes": "18:00"
      }
    ],
    "priceRange": "$40-$320",
    "paymentAccepted": "Credit Card, PayPal",
    "currenciesAccepted": "USD",
    "areaServed": [
      {
        "@type": "City",
        "name": "New York",
        "sameAs": "https://en.wikipedia.org/wiki/New_York_City"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Brooklyn",
        "sameAs": "https://en.wikipedia.org/wiki/Brooklyn"
      },
      {
        "@type": "AdministrativeArea", 
        "name": "Manhattan",
        "sameAs": "https://en.wikipedia.org/wiki/Manhattan"
      }
    ],
    "serviceType": "Walking Tours",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Cat History Walking Tours",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Brooklyn Heights Cat History Tour",
            "description": "Historical walking tour of Brooklyn Heights featuring famous cats"
          },
          "price": "40",
          "priceCurrency": "USD"
        },
        {
          "@type": "Offer", 
          "itemOffered": {
            "@type": "Service",
            "name": "Financial District Cat History Tour",
            "description": "Historical walking tour of Financial District featuring Wall Street cats"
          },
          "price": "40",
          "priceCurrency": "USD"
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service", 
            "name": "Lower East Side Cat History Tour",
            "description": "Historical walking tour of Lower East Side featuring immigrant cats"
          },
          "price": "40",
          "priceCurrency": "USD"
        }
      ]
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "150",
      "bestRating": "5",
      "worstRating": "1"
    },
    "image": [
      "https://catsabouttowntours.com/lovable-uploads/f0cb5bcd-d58d-44ab-9619-011f839bec4f.png",
      "https://catsabouttowntours.com/lovable-uploads/e100a577-5b2e-45e7-8c5a-045a615b98ba.png",
      "https://catsabouttowntours.com/lovable-uploads/cf69d03b-6e71-43d3-936d-5465eaa5212f.png"
    ],
    "logo": "https://catsabouttowntours.com/lovable-uploads/a7814c71-1569-43b8-8a9c-e24f811be427.png",
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": "+1-917-555-CATS",
        "contactType": "customer service",
        "email": "catsabouttowntour@gmail.com",
        "availableLanguage": "English",
        "areaServed": "US"
      },
      {
        "@type": "ContactPoint",
        "contactType": "reservations",
        "email": "catsabouttowntour@gmail.com",
        "availableLanguage": "English"
      }
    ],
    "sameAs": [
      "https://www.instagram.com/catsabouttowntours/",
      "https://www.facebook.com/catsabouttowntours/"
    ],
    "foundingDate": "2024",
    "founder": {
      "@type": "Person",
      "name": "Peggy Gavan",
      "jobTitle": "Cat Historian and Tour Guide"
    },
    "knowsAbout": [
      "NYC History",
      "Feline History", 
      "Brooklyn Heights",
      "Financial District",
      "Lower East Side",
      "Walking Tours",
      "Cat Culture"
    ],
    "slogan": "NYC's Premier Cat History Walking Tours"
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default LocalBusinessSchema;